import Link from "next/link";

import Modal from "components/shared/modal";
import ButtonLink from "components/shared/buttonLink";
import { LOCAL_STORAGE_KEY } from "@/constants/owner/management/localStorageKey";

type Props = {
  showShareModal: boolean;
  setShowShareModal: React.Dispatch<React.SetStateAction<boolean>>;
};

//仕事共有モーダル
const TaskShareUrlCopyModal_caseNoSelect: React.FC<Props> = ({
  showShareModal,
  setShowShareModal
}) => {
  return (
    <Modal
      show={showShareModal}
      showClose={true}
      setShow={setShowShareModal}
      title="この仕事は共有対象外です"
    >
      <div className="px-32 pb-16 pt-8 text-[1.4rem] leading-normal">
        <p>設定画面で該当する不動産タイプと仕事を選択してください。</p>
        <div
          className="mb-8 mt-8"
          onClick={() =>
            sessionStorage.setItem(LOCAL_STORAGE_KEY.SAVE_TAB_VALUE_KEY, "0")
          }
        >
          <Link href="/owner/management" passHref>
            <ButtonLink width="100%" btnColor="pink">
              共有する仕事を選択する
            </ButtonLink>
          </Link>
        </div>
      </div>
    </Modal>
  );
};

export default TaskShareUrlCopyModal_caseNoSelect;
